<template>
  <div id="solution">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner" style="background-image: url('https://img.deepbaytech.com/fn/solution.jpg')">
          <div class="swiper-slide-title">
            <div style="font-size: 48px; padding-left: 20px; margin: 0 auto;">一站式解决方案</div>
            <div style="font-size: 20px; padding-left: 20px; margin: 12px auto 18px auto">云 + 智能
              一站式解决方案，减少流程，提高效率</div>
            <a @click="hClick" class="service">服务咨询</a>
          </div>
        </div>
      </div>
    </div>
    <!--弹框-->
    <el-dialog :lock-scroll="false" v-if="dialogVisible" title="服务咨询" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" @close="hClose">
      <el-form class="dialog" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :label-position="labelPosition">
        <el-form-item label="联系人：" prop="username">
          <el-input v-model.trim="ruleForm.username" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model.number="ruleForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model.trim="ruleForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="公司名称：" prop="companyName">
          <el-input v-model.trim="ruleForm.companyName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="所在地：" prop="companyAddr">
          <el-input v-model.trim="ruleForm.companyAddr" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="问题描述：" prop="question">
          <el-input type="textarea" placeholder="请输入" v-model.trim="ruleForm.question" resize="none">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="success" @click="submitForm" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <div class="container">
      <div class="solution-container">
        <div class="solution-container-title">行业解决方案</div>
        <div class="solution-tab">
          <ul class="solution-tab-header" id="tabList">
            <li v-for="(solutionTab,index) in solutionTabs" :key="index" :class="{'active-tab1' : isShow==index}" @click="tabHandle(index)">
              {{solutionTab.tabname}}</li>
          </ul>
          <div class="solution-main" id="main">
            <div class="solution-main-c" :class="{'active-main': isShow !== 0}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧安防</p>
                <p class="solution-main-title-text">
                  智慧安防：纵观安防发展历程，从“看得到”、“看得远”、“看得清”发展到今天的”看得懂“，AI技术将成为推动安防行业的主要力量，以智能方式随时随地保护城市里每一个人的生命财产安全。
                </p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧校园</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af1-1.png" text="通过动态人脸识别技术实现对学生进出实现信息电子化、自动化记录，形成登记信息要素。方案利用成熟……" title="校门、宿舍进出识别"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af1-22.png" text="考场使用AI人脸特征和行为识别摄像，监督考场纪律，对于缺考情况精准掌握，对扭头等行为实时监控。" title="考场异常行为"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af1-3.png" text="通过视频流接入，提供针对人群的实时分析服务。支持人数统计、人员密度统计、安全级别统计、事件类型统计等功能；能自定义异常情况的标准，并在异常情况发生时进行报警提醒，帮助管理人员进行决策制定。" title="校内异常行为"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧工地</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af2-1.png" text="对施工人员不按安全规范穿戴安全服或安全帽的行为进行识别并迅速告警，提高安全监管效率。" title="安全帽检测"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af2-2.png" text="人证对比技术可将有合法上岗证件的员工进行人脸入库，在工地现场将员工人脸与持证人员库进行比对，杜绝无证上岗，降低安全隐患。" title="人证对比"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af2-3.png" text="对于非工作人员禁止入内区（禁非区）进行全面实时监控，任何非工作人员一经进入区域马上告警。" title="禁非区防控"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af2-4.png" text="对摄像头画面进行火焰识别分析，迅速高效，可有效弥补传统烟感报警装置在通风区域的缺陷。" title="明火识别"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧园区</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af3-1.png" text="基于人脸识别技术，用以区分园区在住人员和外来人员的管理考勤，事前检测预防、事后追查。" title="人员考勤管理"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af3-2.png" text="通过分析摄像头画面，进行人像快速对比，识别访客或者黑名单人员。" title="访客黑名单"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af3-3.png" text="现场刷脸签到提升管理效率。" title="会议签到"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af3-4.png" text="基于车辆、车牌识别技术，有效解决园区有限车位的管理问题，同时对外来车辆进行监控存档。" title="车辆管理"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af3-5.png" text="针对特定时段、私密性区域进行监控，对违规进入人员进行记录和预警。" title="关键区域监控"></li>
                  </ul>
                </div>
                <!-- 第四个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧警务</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af4-1.png" text="分析视频中的车辆特征信息，包括车牌、车身、内饰、标志物、驾驶员人脸等，以车辆图像特征做以图搜图，对假套牌车、同行车、频繁过车等行为进行智能分析，应用于刑事侦查、稽查布控、重大安保及信息情报等领域。" title="车辆侦查"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af4-2.png" text="对监控视频中可疑人员进行人脸识别，进行嫌犯追逃、重点人员防控等。" title="人脸侦查"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af4-3.png" text="基于人脸识别与大数据计算技术，从公安实战业务出发，集实时监控重点道路及路口人流，利用AI+大数据技术，为交通、图侦、治安、情报等业务警种提供有力的技术支持。" title="重点道路监控"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/af4-4.png" text="提供人像布控，系统设定黑名单管理机制，一旦黑名单中的人员进入监控范围，系统自动发出预警，提醒安保人员。提供复杂场景的快速准确识别，解决人流量大的场景下低头、侧脸、逆光、遮挡等问题。" title="重点场合监控"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 1}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧金融</p>
                <p class="solution-main-title-text">
                  智慧金融：资深行业专家依托人工智能、大数据、云计算等金融科技手段，在业务流程、业务开拓和客户服务等方面助力企业实现金融产品、风控、获客、服务的智慧化。</p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧银行</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr1-1.png" text="利用RPA技术自动模仿人的动作对系统进行操作，自动快速进行重复性工作，提高工作效率。" title="业务助手"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr1-2.png" text="基于人工智能算法、用户行为画像、人机识别、团伙检测等多项AI技术，帮助有效识别欺诈行为，提升风控效率，减少业务损失。" title="智能信贷"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr1-3.png" text="智能客服机器人24小时接听客户反馈信息和电话，帮助客户处理问题。还能转接人工，协助人工规范用语和回答问题。" title="智能客服"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">金融服务</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr2-1.png" text="基于人脸活体检测、智能OCR助力证劵客户远程开户。" title="远程开户"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr2-2.png" text="利用自然语言处理，深度学习，知识图谱等前沿技术，挖掘海量金融文本数据，帮助金融机构实现智能化业务驱动。" title="智能投研"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr2-3.png" text="根据设置的规则，智能对文件进行指定操作，对客户资料，经营信息等文档快速整理。" title="文档整理"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧保险</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr3-1.png" text="AI数字员工成员（智能客服、智能业务助理、智能对话分析师、智能业务培训师）助力保险行业智能化。" title="智能字数员工"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr3-2.png" text="借助机器视觉、知识图谱、NLP等技术，智能审核被保险人的身份、识别理赔材料完整与真实性、被保险人诊疗信息等信息，对客户的智能快速核保理赔。" title="核保理赔"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jr3-3.png" text="借助机器视觉、知识图谱、技术，智能识别目标损坏位置和程度，快速帮助定损。" title="智能定损"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 2}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧制造</p>
                <p class="solution-main-title-text">
                  智慧制造：将传统机器视觉与现代人工智能结合，使用大数据分析建模对工业流程与设备维护进行预测，智能优化物流运输与配货仓库，打造新一代制造业。</p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">仓储物流</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz1-1.png" text="通过全链条业务流程、数据、决策等大数据分享。运输端到端解决方案包括从全局仓网布局选址，到每日运作层面的分拨调度，协助解决遇到的运输难题。" title="运输优化"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz1-2.png" text="上游来料不固定，种类多，同一托盘上载有不同尺寸的箱子，混杂堆叠，利用AI+3D视觉及机器人运动规划技术，将产品逐一拆到下游箱式输送线。" title="混合拆垛"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz1-3.png" text="产品种类极多，深箱抓取作业空间局限，产品经周转箱输送到机器人工作站，利用AI+3D视觉识别定位技术，根据订单要求，引导机器人抓取指定个数的产品到订单周转箱,完成拆零拣选作业。" title="机器人拣选"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">制造服务</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz2-1.png" text="通过视频自动分享工作服、安全帽等着装信息，一旦发现未着装工作人员，系统自动提出警告。" title="着装检测"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz2-2.png" text="提供单人人脸识别，多人人脸识别，根据实际情况设置多级保护区域，根据授权对进入的人员进行识别。" title="人脸安防"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">工业装配</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz3-1.png" text="以高稳定性与精度实现耐火砖搬运码垛应用，发挥其臂展与高定位精度的优势，为流水线上的耐火材料码垛，衔接耐火材料加工流水线与托盘运输流水线。" title="码垛"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz3-2.png" text="在自动化生产线上，多台机器人协作共同完成搬运工作，高速稳定完成压缩机连线无故障生产。" title="搬运"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz3-3.png" text="机器人在打磨、抛光、去毛刺领域成功实现批量使用。能实现快速对复杂曲面的示教编程，快速实现局部轨迹的优化，大幅缩短产品切换的调产周期，提高了机器人应用的效率和可复制性。" title="打磨"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zzzz3-41.png" text=" 实现薄板与较厚圆管之间的焊接，高精度，灵活性好。同时单工位上可以放置多个零部件，实现多个零件连续焊接，尽量提高机器人工作时间，大大的提高了生产效率。" title="焊接"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz3-5.png" text=" 机器人手腕结构灵活，末端承载能力高，配备多枪喷涂可极大提高生产效率。目前在多行业零部件生产线均有成熟应用案例，可极大地提高客户生产效率。" title="喷涂"></li>
                  </ul>
                </div>
                <!-- 第四个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">视觉检测</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz4-1.png" text=" 基于深度学习的智能工业视觉平台，用于解决复杂缺陷的定位、检测、分类等问题，适用于各类复杂应用场景，具有强大的兼容性。同时又具有强大的自学习功能，伴随着软件的持续运行，缺陷检出率会不断提升。" title="缺陷检测"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz4-21.png" text="料箱分拣机器人的高柔性的货到人机器人，适用于不同高度的货位，实现自动完成升降、抓取料箱和搬运工作，以实现仓储自动化。采用自主研发的视觉导航定位系统，无需对使用环境进行改造，机器人可以准确拣取目标货物，吸取或夹抱等多种末端执行方式。" title="物料分类"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz4-2.png" text="能够实现对产品的自动三维高精度测量与缺陷检测，对不合要求的产品进行汇报和自动分拣，特别针对高精度测量，人工测量无法满足精度和稳定性要求。" title="三维视觉测量"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz4-3.png" text="印刷质量检测、印刷字符检测、颜色识别、条码识别、二维码检测。" title="印刷检测"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/zz4-4.png" text=" 智能设备管理，将设备使用过程中积累的海量数据进行深度挖掘形成经验知识，并反馈作为设备改善的依据，从而形成闭环的、全生命周期的设备信息管理。主要功能包括故障诊断、事故预防、寿命预测、备件管理、智能点检。" title="设备维护"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 3}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧医疗</p>
                <p class="solution-main-title-text">
                  智慧医疗：以医疗健康大数据和知识库为基础，运用机器学习、知识谱图、自然语言处理、人机交互等人工智能技术，赋予医疗健康服务和管理智能感知、学习、预警、预测等能力，为个人、医生、医院等医疗健康主体提供虚拟助理、健康管理、医院管理等场景化应用，提升医疗服务体验、提高健康管理水平、提高医院管理决策水平。
                </p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">医疗服务</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl1-1.png" text=" 通过基于大数据技术的临床数据分析建模、电子病历结构化、构建知识图谱、医学知识库、可视化组件、大数据平台等系统。" title="智慧医院"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl1-2.png" text=" 智能导诊助手适用于门诊预诊台、门诊护士台、病区护士台，为患者提供导诊分诊、院内地图导航、就医流程指导、院内信息传达、医疗知识宣教等工作。" title="导诊助手"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl1-3.png" text=" 病房机器人适用于核医学科病房患者的治疗服务，机器人能够代替医护人员进入辐射隔离区，执行病人生命体征测量，辐射防护宣教，辐射残留及环境放射检测，送药，巡诊，查房等病房服务，并提供远程视频问诊，实时回答病患疑问等增值服务。在保护医护人员安全的同时，最大程度提高患者治疗精细化管理。" title="病房服务机器人"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">医疗诊断</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl2-111.png" text="使用AI技术加速辅助筛查新冠状肺炎患者，辅助医生评估患者肺部受累情况，智能评估病情和疗效。" title="新冠肺炎辅助筛查"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl2-222.png" text=" 基于机器视觉与深度学习技术，智能检测出头颅CT/MRI多模态影像中的急性出血、缺血病灶。精准确定病灶区域，完成对出血病灶的分类、出血量的测量，同时具备随访对比功能，最大程度的符合临床应用场景，协助医生准确进行病情评估，使患者第一时间获得最优治疗方案。" title="CT 脑卒中"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl2-33.png" text="病灶:包括结节，气胸，骨折、肺结核、肺感染、主动脉结钙化、条索影、 心影增大、胸腔积液等。" title="DR 胸部疾病"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">健康</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl3-1.png" text="皮肤底层的秘密，仅凭肉眼判断并不准确，了解皮肤的真实状态，科学护肤事半功倍。" title="AI测肤"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl3-2.png" text="皮全生命周期健康监测及管理，结合AI算法提升就诊效率。病史数据结构化、运用AI算法对人体数据进行分析及风险评估、打造多维度健康管理。" title="健康管理"></li>
                  </ul>
                </div>
                <!-- 第四个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">医学研究</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl4-11.png" text="此款基于GPU和内存计算数据快速分析平台。实现从FASTQ文件读取原始测序数据，快速完成序列比对，排序/去重复和变异识别等一系列NGS数据处理流程，并以SAM/BAM/VCF等标准文件格式输出结果。" title="基因测序"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/yl4-22.png" text="将病程相关的数据整合，通过医学自然语言处理引擎实现科研数据的精深治理和高效转化，形成科研大数据中心，提升临床科研效率，加速学科建设。" title="临床研究"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 4}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧城市</p>
                <p class="solution-main-title-text">智慧城市：借助功能强大的 AI 驱动型智能视频分析
                  (IVA)现可实现从数十亿个传感器和其他物联网 (IoT) 设备中收集数据和提取见解，可持续发展城市，维护基础设施，并为居民和社区改善公共服务。</p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">新零售</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/cs1-1.png" text=" 以人脸识别算法为基础实时识别并推送顾客画像，实现门店的前置营销和个性化服务，助力门店提升接待效率、增强营销转化、挖掘潜在客群、维护顾客忠诚度。" title="顾客识别"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/cs1-2.png" text=" 通过AI商品识别技术在自助结算。" title="自助结算"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/cs1-3.png" text="能够以AI商品识别技术完成对传统货柜的智能化改造，实现“即拿即走，自动结算”的智能购物流程，并以更低的成本为消费者提供更优质的体验。" title="智能货柜"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/cs1-4.png" text="基于AI商品识别技术，可将普通的自助蔬果秤改造为智能称重台，赋予其自动识别称重商品的功能。该解决方案支持蔬菜、水果、干杂等300多个品类商品的识别，即使在商品已装袋的情况下也可完美应对。在帮助零售商更好地节约人力成本、保障资产安全的同时，为顾客提供更加流畅、高效、友好的自助称重体验。" title="智能称重"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/cs1-5.png" text="使用高精度摄像头通过AI智能防损系统对商品进行高精度识别防损，识别漏扫，将扫码分散至购物过程中。" title="智能商超购物车"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 5}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧交通</p>
                <p class="solution-main-title-text">
                  智慧交通：全球每年交通事故造成2000万至5000万人受伤，带来的损失高达5180亿美元，人工智能技术接替人类执行交通管制，7*24小时监控优化交通路况。自动驾驶、车内行驶监控、交通智能优化让驾驶更智能、规范和安全。
                </p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">交通管理</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt1-1.png" text="基于车路协同（V2X）的智能道路，可以减少交通事故和交通堵塞、提高通行效率、并降低油耗。能为自动驾驶及智慧城市提供泛在连接技术和多元应用服务。" title="车路协同"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt1-2.png" text="城市主要干线路网为重点，通过采集车拍摄含有地理坐标信息的道路及交通设施照片，形成交通设施高精度全量数据库，积累了TB级的基础数据。将道路线型、路口结构、标志标线以及信号灯配时等交通元素全部纳入交通大脑进行电子化信息化管理，实现了道路通行状况、交通流量、警力分布、设备运行状况等各类交管数据的“一图式”呈现。" title="交通违规"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt1-3.png" text="视频车辆检测、车辆身份比对、车牌识别、收费车型识别、车脸识别、大视域车位感知、车辆多维特征识别、交通异常事件识别。" title="异常事件发现"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt1-31.png" text=" 运用事先学习、目标跟踪等多种关键技术，抽象行人模型，感知行人轨迹，结合红绿灯状态综合判断行人闯红灯违法行为，输出一组“违法过程图片+违法短时录像”的完整证据链。" title="红灯人脸识别"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">自动驾驶</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt2-1.png" text="基于数据和对实际路况的分析，能对车辆、行人、车道、信号灯以及交通标志等道路目标和可行驶区域进行精确描述与定位。" title="道路环境感知"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt2-2.png" text="通过基于神经网络的视觉感知以及多传感器技术，进行眼睑检测、视线追踪、头部姿态识别、肢体检测以及物体检测，智能分析驾乘人员的状态及行为。" title="舱内感知"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt2-3.png" text="通过对驾驶轨迹的学习，算法可以根据当前环境感知和高精地图信息，做出驾驶决策规划。" title="驾驶决策"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智能停车</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-1.png" text="打造智能化停车场综合管理系统，实现出入口无人化值守、可视化智能车位引导及反向寻车、可视化智能运营管理，达到车主停车舒心、管理单位管理省心的目的，既提升了车主停车体验，又节约了维护管理成本。" title="自动泊车"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-2.png" text="赋予传统量产车辆自动驾驶的基础能力，即稳定可靠地实现对车辆的行驶、制动、转向和换挡以及灯光的控制。" title="代客泊车"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-3.png" text=" 沟通物联网、通过专网汇聚了海量的交通数据、利用大交通分析技术，对海量级的交通数据进行关联分析和统计挖掘、为用户提供交通全业务服务。搭建智能交通管控和服务平台、为构建智慧城市和平安城市提供交通数据和交通服务。" title="智能停车场"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-4.png" text="实现了停车位数据采集、状态监控、停车位查找、执法监管等项创新功能。综合利用了车辆检测传感技术、无线通信技术、虚拟化技术，并基于云计算、大数据处理、移动联网等新兴的前沿技术，起到了对城市资源的高效管理，对停车行为的实时监控。" title="路边停车"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 6}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智慧教育</p>
                <p class="solution-main-title-text">
                  智慧教育：借助人工智能技术人脸识别、行为分析、语音识别、知识图普大数据，对课堂情况教师学生双向智能分析，提升学生学习热情，优化教学质量。课堂行为识别能够协助双师远程教师教学，增强教学互动，助力偏远教育。
                </p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智慧教育</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jy1-1.png" text="借助大数据与人工智能技术，分析学生常态化学情，帮助老师预设教学重点，打造课前、课中、课后以生为本的教学闭环场景。" title="课堂质量"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jy2-1.png" text="对学生的英文发音进行评分，纠错，提升课堂语音互动效果、进行学生英文发音矫正。" title="口语能力"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jy3-1.png" text="考场使用AI人脸特征和行为识别摄像，监督考场纪律，对于缺考情况精准掌握，对扭头等行为实时监控。" title="考场作弊"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jy4-1.png" text="基于人工智能技术可实现高效智能排课，依托学科潜能测评帮助教师因材施教。" title="高效管理"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 7}">
              <div class="solution-main-title">
                <p class="solution-main-title-h">智能文创</p>
                <p class="solution-main-title-text">智能文创：使用 AI 助手减少重复性任务，加速内容创作。 数据分析有助更深入地了解观众。</p>
                <hr />
              </div>
              <div class="solution-main-content">
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">场景识别</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc1-1.png" text="基于深度学习的图像鉴黄技术，精准识别图片及视频中的涉黄内容。" title="智能鉴黄"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc1-2.png" text="基于先进的深度学习算法，AI可以识别并快速检测视频/图片/文本中的涉黄、暴力、政治敏感等风险内容，高效遏制风险、全面释放审核人力、提高审核效率、净化网络环境、提升用户体验。" title="敏感人物识别"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc1-3.png" text=" 基于先进的深度学习算法，AI可以识别并快速检测视频/图片/文本中的涉黄、暴力、政治敏感等风险内容，高效遏制风险、全面释放审核人力、提高审核效率、净化网络环境、提升用户体验。" title="暴恐识别"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc1-4.png" text="通过对图像进行分析和处理，自动抽取其中的文字内容，转换为可编辑检索的字符串形式。" title="文字识别"></li>
                  </ul>
                </div>
                <!-- 第二个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">内容制作</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc2-1.png" text="利用AI技术，全⾃动进⾏画⾯面分辨率提升、场纹划伤压缩痕等修复、面部重点纹理细节补足。" title="影视修复"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc2-2.png" text="使用AI辅助绘图、AI配音帮助快速制作宣传视频。" title="宣传制作"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc2-31.png" text="海量素材、AI智能绘图、多元化的AI配音，可轻松生成喜欢的短视频。" title="短视频生成"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/wc2-4.png" text="" title="目标追踪剔除"></li>
                  </ul>
                </div>
                <!-- 第三个 -->
                <div class="solution-main-content-d">
                  <div class="solution-main-content-d-title">
                    <span class="solution-main-content-d-title-quan"></span>
                    <span class="solution-main-content-d-title-text">智能广告</span>
                  </div>
                  <ul class="solution-main-content-d-ul">
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-1.png" text="能识别各种场景、行为等事件，自动为视频打标签。" title="场景识别"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-2.png" text="智能标注情景标签，精准匹配品牌广告。" title="广告插播"></li>
                    <li is="solutionItem" imgurl="https://img.deepbaytech.com/fn/jt3-3.png" text="" title="图片同款"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务咨询 -->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
import solutionItem from "./components/solutionItem"
import { getServiceConsultation } from "@/api";
export default {
  name: 'Solution',
  components: {
    Consultation,
    Footer,
    solutionItem
  },
  data () {
    return {
      dialogVisible: false,
      textarea: '',
      active: '',
      isShow: 0,
      labelPosition: 'left',
      ruleForm: {
        username: '',
        phone: '',
        email: '',
        companyName: '',
        companyAddr: '',
        question: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入联系人名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '请输入正确的邮箱', trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        companyAddr: [
          { required: true, message: '请输入所在地', trigger: 'blur' }
        ],
        question: [
          { required: true, message: '请输入问题描述', trigger: 'blur' },
        ],
      },
      solutionTabs: [
        { "tabname": "智慧安防" },
        { "tabname": "智慧金融" },
        { "tabname": "智能制造" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧城市" },
        { "tabname": "智慧交通" },
        { "tabname": "智慧教育" },
        { "tabname": "智能文创" }
      ]
    }
  },
  mounted () {
    new Swiper('#banner', {
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
  methods: {
    tabHandle (flag) {
      this.isShow = flag
    },
    handleClose () {
      this.dialogVisible = false
      this.ruleForm = {}
    },
    hClose () {
      this.ruleForm = {}
    },
    hClick () {
      this.dialogVisible = true
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          getServiceConsultation(this.ruleForm).then(() => {
            alert('发送成功')
            this.dialogVisible = false
            console.log(this.ruleForm)
          })
        } else {
          alert('请输入必填项')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
hr {
  border: none;
  height: 1px;
  background-color: #e5e5e5;
}
li {
  list-style: none;
}
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.service {
  font-size: 16px;
  margin: 12px auto 18px 20px;
  text-decoration: none;
  display: inline-block;
  width: 140px;
  height: 40px;
  background: #77ba00;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
}
.container {
  width: 100%;
  min-width: 1180px;
}
.solution-container {
  width: 100%;
  background-color: #fff;
}
.solution-container-title {
  width: 1180px;
  font-size: 32px;
  margin: 40px auto 24px auto;
}
.solution-tab-header {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 1180px;
  margin: auto;
}
.solution-tab-header li {
  width: 140px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  border: 1px solid rgba(204, 204, 204, 1);
  border-left: 1px solid rgba(204, 204, 204, 0);
  margin-bottom: 16px;
}
.solution-tab-header li:nth-child(8n + 1) {
  border-left: 1px solid rgb(204, 204, 204, 1);
}
.solution-tab-header li:not(.active-tab1):hover {
  color: #77ba00;
  border: 1px solid #77ba00 !important;
}
.active-tab1 {
  background: #77ba00;
  color: #ffffff;
  border: 1px solid #77ba00 !important;
}
.active-main {
  display: none;
}
.solution-main {
  margin-top: 20px;
  background-color: #f6f8fb;
}
.solution-main-c {
  width: 1180px;
  margin: auto;
}
.solution-main-title-h {
  font-size: 32px;
  color: #333333;
  padding-top: 40px;
}
.solution-main-title-text {
  font-size: 16px;
  color: #333333;
  padding: 12px 0 20px 0;
}
.solution-main-content {
  margin-top: 54px;
}
.solution-main-content-d-title-text {
  font-size: 24px;
  color: #77ba00;
}
.solution-main-content-d-ul {
  padding-bottom: 48px;
  display: flex;
  flex-wrap: wrap;
}
.solution-main-content-d-ul-li {
  width: 280px;
  height: 294px;
  background: #ffffff;
  margin-top: 20px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  margin-right: 15px;
  overflow: hidden;
}
.solution-main-content-d-ul-li:hover {
  cursor: pointer;
  background-color: #77ba00;
}
.solution-main-content-d-ul-li:hover p {
  color: #fff !important;
}
.solution-main-content-d-ul-li img {
  width: 280px;
  height: 168px;
  transition: all 0.5s;
}
.solution-main-content-d-ul-li img:hover {
  transform: scale(1.2, 1.2);
}
.solution-main-content-d-ul-li-all {
  padding: 16px;
}
.solution-main-content-d-ul-li-title {
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}
.solution-main-content-d-ul-li-text {
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.solution-main-content-d-ul-li:hover {
  cursor: pointer;
  background-color: #77ba00;
}
.solution-main-content-d-ul-li:hover p {
  color: #fff !important;
  overflow: visible;
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px 24px 0 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-textarea__inner {
  height: 144px;
  border-radius: 0;
  padding-left: 12px;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-input__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 15px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
::v-deep .el-input__inner {
  width: 240px;
  height: 32px;
  border-radius: 0%;
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
#solution ::v-deep .el-dialog {
  min-width: 570px;
  margin: 0 auto 0px;
}
</style>
